import type { SeedingFeaturedComment } from '@/app/(activity)/campaigns/[slug]/types';

export function normalizeSeedingComment(
  input?: SeedingFeaturedComment | null,
): SeedingFeaturedComment | null {
  if (!input) return null;

  const content = input.content?.trim() ?? '';
  if (!content) return null;

  return {
    reviewer: input.reviewer,
    content,
  };
}

export function getSeedingCommentText(comment?: SeedingFeaturedComment | null): string {
  return comment?.content?.trim() ?? '';
}

export function normalizeSeedingComments(
  list?: SeedingFeaturedComment[],
): SeedingFeaturedComment[] {
  if (!list?.length) return [];

  return list
    .map((item) => normalizeSeedingComment(item))
    .filter((item): item is SeedingFeaturedComment => item != null);
}
